import styled from '@emotion/styled';
import { createElement, FC, useContext } from 'react';
import { useRecoilValue } from 'recoil';

import ProjectFileList from '../component/compound/ProjectAssetEditor/ProjectFileList';
import { context as DependencyContext } from '../context/dependency';
import { editingProjectAssetFilesStateAtom } from '../page/ProjectEditingPage/atoms/editingProjectStateAtom';
import { useAssetFiles } from '../page/ProjectEditingPage/hooks/useAssetFiles';
import { FileIdsValue } from '../types/DynamicSchema';
import { Meta } from '../types/Meta';

type Props = {
  meta: Meta;
  fieldKey: string;
  fileIds: FileIdsValue;
  bucketId: string;
  disabled: boolean;
};

export const EnhancedProjectFileList: FC<Props> = ({ meta, fieldKey, fileIds, bucketId, disabled }) => {
  const {
    removeAssetFile,
    addAssetFile,
    addUploadingAssetFiles,
    removeUploadingAssetFile,
    updateUploadingAssetFilesProgress,
    removeUploadingAssetFilesProgress,
  } = useAssetFiles();
  const { assetFiles, uploadingAssetFilesProgress } = useRecoilValue(editingProjectAssetFilesStateAtom);
  const {
    editProjectUsecase: { deleteAssetFile, uploadAssetFiles },
  } = useContext(DependencyContext);

  return (
    <StyledProjectFileList
      disabled={disabled}
      bucketId={bucketId}
      meta={meta}
      fieldKey={fieldKey}
      fileIds={fileIds}
      filesProgress={uploadingAssetFilesProgress[fieldKey] || {}}
      projectFiles={assetFiles}
      onRequestDeleteFile={(file) => deleteAssetFile({ fileReference: file, fieldKey, bucketId, removeAssetFile })}
      onRequestUploadFiles={(files, bucketId) =>
        uploadAssetFiles({
          files,
          bucketId,
          assetCategoryFieldKey: fieldKey,
          addUploadingAssetFiles,
          updateUploadingAssetFilesProgress,
          handleFileUploadFinished: async (file, fileReference, assetCategoryFieldKey) => {
            await removeUploadingAssetFilesProgress(file, assetCategoryFieldKey);
            await removeUploadingAssetFile(file, assetCategoryFieldKey);
            await addAssetFile(fileReference, assetCategoryFieldKey);
          },
        })
      }
    />
  );
};

const StyledProjectFileList = styled(ProjectFileList)<{ disabled: boolean }>`
  ${({ disabled }) => disabled && 'opacity: 0.8;'};
  ${({ disabled }) => disabled && 'background: #e8e8e8;'};
`;
